var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_2989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0057 14.6914C13.4086 15.0894 12.7151 15.2999 12 15.2999C11.285 15.2999 10.5914 15.0894 9.99431 14.6914L0.159797 8.13483C0.105234 8.09845 0.0520781 8.06053 0 8.02153V18.7651C0 19.9969 0.999609 20.9745 2.20936 20.9745H21.7906C23.0224 20.9745 24 19.9749 24 18.7651V8.02148C23.9478 8.06058 23.8945 8.09859 23.8398 8.13502L14.0057 14.6914Z",
    fill: "#FB8E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.939844 6.96525L10.7744 13.5218C11.1466 13.77 11.5733 13.8941 12 13.8941C12.4267 13.8941 12.8534 13.77 13.2256 13.5218L23.0602 6.96525C23.6487 6.57314 24 5.91689 24 5.20861C24 3.99075 23.0092 3 21.7914 3H2.20861C0.990797 3.00005 0 3.9908 0 5.20978C0 5.91689 0.351375 6.57314 0.939844 6.96525Z",
    fill: "#FB8E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_2989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d7ebba9692c8464a901b2b539c969043.svg";
export { ForwardRef as ReactComponent };